import { render, staticRenderFns } from "./QuestionListeningSpell.vue?vue&type=template&id=ecdb9e76"
import script from "./QuestionListeningSpell.vue?vue&type=script&lang=js"
export * from "./QuestionListeningSpell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports